import React from 'react';
import { useLanguage } from '../lib/i18n';
export function Marquee() {
  const {
    t
  } = useLanguage();
  const TEXT = t.marqueeText;
  return <div className="w-full overflow-hidden border-y border-border py-4 relative z-10 bg-background mt-16 md:mt-0" data-id="element-214">
      <div className="flex w-max animate-marquee" data-id="element-215">
        <div className="flex whitespace-nowrap" data-id="element-216">
          {[...Array(6)].map((_, i) => <span key={`first-${i}`} className="text-xs text-muted tracking-[0.3em] uppercase font-light px-8" data-id="element-217">
              {TEXT}
            </span>)}
        </div>
        <div className="flex whitespace-nowrap" data-id="element-218">
          {[...Array(6)].map((_, i) => <span key={`second-${i}`} className="text-xs text-muted tracking-[0.3em] uppercase font-light px-8" data-id="element-219">
              {TEXT}
            </span>)}
        </div>
      </div>
    </div>;
}